import React, { useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import ContractForm from '../components/contract/ContractForm';
import ContractPreview from '../components/contract/ContractPreview';

const ContractPage = () => {
  const [formData, setFormData] = useState({
    buyer: {
      type: 'pf', // 'pf' para pessoa física, 'pj' para pessoa jurídica
      name: '',
      cpf: '',
      address: '',
      city: '',
      state: '',
      companyName: '',
      cnpj: '',
      representative: '',
      representativeCpf: '',
    },
    products: [],
    payment: {
      type: 'vista', // 'vista' ou 'prazo'
      method: 'boleto', // 'boleto', 'cartao', 'pix', 'especie'
      installments: [
        { number: 1, amount: 0, date: '' },
        { number: 2, amount: 0, date: '' },
        { number: 3, amount: 0, date: '' },
      ],
      total: 0,
    },
    delivery: {
      type: 'retirada', // 'retirada' ou 'entrega'
      address: '',
      city: '',
      state: '',
      zipCode: '',
      dates: [
        { date: '', items: [] }
      ]
    }
  });

  const handleFormChange = (newData) => {
    setFormData({
      ...formData,
      ...newData
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-primary mb-8">Criar Novo Contrato</h1>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Formulário à esquerda */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <ContractForm data={formData} onChange={handleFormChange} />
          </div>
          
          {/* Preview à direita */}
          <div className="bg-white rounded-lg shadow-md p-6 overflow-auto max-h-[800px]">
            <h2 className="text-xl font-semibold mb-4">Prévia do Documento</h2>
            <ContractPreview data={formData} />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ContractPage;